import { PAYMENT_AMOUNT_STEP } from 'features/config/ConfigConditionSchemas'
import { useConfigConditionValue } from 'features/config/useConfigConditionValue'

const FALLBACK_STEP = 1
const DEFAULT_PERCENT = 5
const DEFAULT_SNAP_PERCENT = 10

// A 1-unit step put ~560 stops on a ~300px track, so staff dragging to the end
// landed short of 100%. Both knobs are overridable via `payments:amountStep`.
const usePaymentAmountSlider = (max: number) => {
  const config = useConfigConditionValue(
    PAYMENT_AMOUNT_STEP,
    'paymentAmountStep'
  )
  const percent = config?.percent ?? DEFAULT_PERCENT
  const snapPercent = config?.snapPercent ?? DEFAULT_SNAP_PERCENT

  const step = max > 0 ? (max * percent) / 100 : 0

  return {
    step: step > 0 ? step : FALLBACK_STEP,
    snapPercent,
  }
}

export default usePaymentAmountSlider
